import axios from "axios";
import { Notify } from "vant";
import router from "../router";

axios.defaults.baseURL = "/api";
const service = axios.create();

/* 请求拦截器 */
service.interceptors.request.use(
  (config) => {
    if (window.localStorage.getItem("token")) {
      config.headers["Authorization"] =
        "Bearer " + window.localStorage.getItem("token");
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/* 响应拦截 */
service.interceptors.response.use(
  (success) => {
    //业务逻辑错误，但接口访问成功
    if (success.status && success.status == 200) {
      if (success.data.code) {
        //内部错误500 尚未登录401 权限不足403
        if (success.data.code == 401) {
          Notify({ message: success.data.message });
          window.localStorage.removeItem("token");

          router.push("/");
        } else if (success.data.message) {
          // Notify({ message: success.data.message })
        }
      } else {
        // const headers = success.headers;
        // let reg = RegExp(/application\/json/);
        // if (headers['content-type'].match(reg)) {
        //     // success.data = unitToString(success.data)
        // } else {
        //     let fileDownload = require('js-file-download');
        //     let fileName = headers['content-disposition'].split(';')[1].split('filename=')[1]
        //     let contentType = headers['content-type'];
        //     fileName = decodeURIComponent(fileName);
        //     fileDownload(success.data, fileName, contentType);
        // }
      }
    }
    return success.data;
  },
  (error) => {
    //访问接口失败
    if (error.response.data.code == 504 || error.response.data.code == 404) {
      Notify({ message: "服务器被吃了" });
    } else if (error.response.data.code == 403) {
      Notify({ message: "权限不足，请联系管理员！" });
    } else if (error.response.data.code == 401) {
      Notify({ message: "尚未登录，请登录" });
      window.localStorage.removeItem("token");
      router.push("/");
    } else {
      //没有响应码
      if (error.response.data.meesage) {
        Notify({ meesage: error.response.data.meesage });
      } else {
        Notify({ message: "未知错误！" });
      }
    }
    return;
  }
);

let base = "";
//请求接口
export const fileRequest = (url) => {
  return service({
    method: "post",
    url: `${base}${url}`,
    responseType: "blob",
  });
};

export const postRequest = (url, params, headers) => {
  return service({
    method: "post",
    url: `${base}${url}`,
    data: params,
    headers: { headers },
  });
};

export const putRequest = (url, params) => {
  return service({
    method: "put",
    url: `${base}${url}`,
    data: params,
  });
};
//请求接口
export const getRequest = (url, params, isLoad) => {
  return service({
    method: "get",
    url: `${base}${url}`,
    params: params,
  });
};

//请求接口
export const deleteRequest = (url, params) => {
  return service({
    method: "delete",
    url: `${base}${url}`,
    data: params,
  });
};
